import Stats from './Stats';

export default Stats;